import { rootApi } from '../rootApi';

/**
 * LMS Eğitim Videoları — `/v1/LmsVideo`. Bkz. docs/LmsVideoApi.md.
 * 
 */
export const lmsVideoApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        getLmsVideoList: builder.query({
            query: ({ modelCode, tittle, feeType, isActive, isPublic, onlyWithVideo, pageNumber, pageSize, sortField, sortOrder } = {}) => ({
                url: 'v1/LmsVideo/GetList',
                method: 'POST',
                body: {
                    modelCode: modelCode || undefined,
                    tittle: tittle || undefined,
                    feeType: feeType ?? undefined,
                    isActive: isActive === 0 || isActive === 1 ? isActive : undefined,
                    isPublic: typeof isPublic === 'boolean' ? isPublic : undefined,
                    onlyWithVideo: onlyWithVideo || undefined,
                    pageNumber: pageNumber || 1,
                    pageSize: pageSize || 12,
                    sortField: sortField || undefined,
                    sortOrder: sortOrder || undefined
                }
            }),
            transformResponse: (response) => {
                if (response && response.data && Array.isArray(response.data.items)) {
                    return { items: response.data.items, totalCount: response.data.totalCount || 0 };
                }
                return { items: [], totalCount: 0 };
            },
            providesTags: ['LmsVideo']
        }),

        getLmsVideoById: builder.query({
            query: ({ id, generateDownloadUrl, urlExpirationMinutes } = {}) => ({
                url: 'v1/LmsVideo/GetById',
                method: 'GET',
                params: {
                    id,
                    generateDownloadUrl: generateDownloadUrl || undefined,
                    urlExpirationMinutes: urlExpirationMinutes || undefined
                }
            }),
            transformResponse: (response) => response?.data || null,
            providesTags: (result, error, arg) => [{ type: 'LmsVideo', id: arg?.id ?? arg }],
            // İzleme adresi taşıyabildiği için (generateDownloadUrl=true) uzun süre önbellekte tutulmaz.
            keepUnusedDataFor: 0
        }),

        addLmsVideo: builder.mutation({
            query: (data) => ({
                url: 'v1/LmsVideo/Add',
                method: 'POST',
                body: data
            }),
            invalidatesTags: ['LmsVideo']
        }),

        updateLmsVideo: builder.mutation({
            query: (data) => ({
                url: 'v1/LmsVideo/Update',
                method: 'POST',
                body: data
            }),
            invalidatesTags: ['LmsVideo']
        }),

        deleteLmsVideo: builder.mutation({
            query: ({ id, hardDelete = false }) => ({
                url: 'v1/LmsVideo/Delete',
                method: 'DELETE',
                params: { id, hardDelete }
            }),
            invalidatesTags: ['LmsVideo']
        }),

        // Adım 1: S3'e ön imzalı yükleme adresi üret. Bu çağrı video kaydının görünür durumunu
        // değiştirmez (aktifleştirme completeLmsVideoUpload ile olur) — invalidatesTags yok.
        generateLmsVideoUploadUrl: builder.mutation({
            query: ({ videoId, fileName, fileSize, expirationMinutes }) => ({
                url: 'v1/LmsVideo/GenerateUploadUrl',
                method: 'POST',
                body: { videoId, fileName, fileSize, expirationMinutes: expirationMinutes || undefined }
            })
        }),

        // Adım 3: S3'e PUT tamamlandıktan sonra çağrılır, dosyayı videoya bağlar ve aktifleştirir.
        completeLmsVideoUpload: builder.mutation({
            query: ({ videoId, fileKey }) => ({
                url: 'v1/LmsVideo/CompleteUpload',
                method: 'POST',
                body: { videoId, fileKey }
            }),
            invalidatesTags: ['LmsVideo']
        }),

        // İzleme adresi — ayrı bir "adres yenile" çağrısı (ör. oynatma sırasında adres dolarsa)
        // için kullanılır; ana izleme akışı genelde getLmsVideoById(generateDownloadUrl:true) ile
        // tek çağrıda çözülür (doc §3.3).
        getLmsVideoDownloadUrl: builder.query({
            query: ({ videoId, expirationMinutes }) => ({
                url: 'v1/LmsVideo/GetDownloadUrl',
                method: 'GET',
                params: { videoId, expirationMinutes: expirationMinutes || undefined }
            }),
            transformResponse: (response) => response?.data || null,
            keepUnusedDataFor: 0
        })
    }),
    overrideExisting: false
});

export const {
    useGetLmsVideoListQuery,
    useLazyGetLmsVideoListQuery,
    useGetLmsVideoByIdQuery,
    useLazyGetLmsVideoByIdQuery,
    useAddLmsVideoMutation,
    useUpdateLmsVideoMutation,
    useDeleteLmsVideoMutation,
    useGenerateLmsVideoUploadUrlMutation,
    useCompleteLmsVideoUploadMutation,
    useGetLmsVideoDownloadUrlQuery,
    useLazyGetLmsVideoDownloadUrlQuery
} = lmsVideoApi;
